import { render, staticRenderFns } from "./RejectResultModal.vue?vue&type=template&id=5fb2f45b&scoped=true&"
import script from "./RejectResultModal.vue?vue&type=script&lang=js&"
export * from "./RejectResultModal.vue?vue&type=script&lang=js&"
import style0 from "./RejectResultModal.vue?vue&type=style&index=0&id=5fb2f45b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb2f45b",
  null
  
)

export default component.exports